import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { RechazosTracesParteIIViewModel } from '../rechazostraces.types';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';

@Component({
    selector: 'app-rechazostraces-parte-ii',
    templateUrl: './rechazostraces-parte-ii.component.html',
})
export class RechazosTracesParteIIComponent extends ComponentBase implements OnInit, OnChanges {
    @Input() formGroup: FormGroup;
    @Input() tracesParteII: RechazosTracesParteIIViewModel;
    @Input() isRechazo = false;

    public isCollapsedControlDocumental = false;
    public isCollapsedControlIdentidad = false;
    public isCollapsedControlFisico = false;
    public isCollapsedControlCOI = false;
    public isCollapsedConclusion = false;
    public isCollapsedCodigoUnidadControl = false;
    public isCollapsedInspectorOficial = false;
    public isCollapsedPCF = false;
    public isCollapsedMedidas = false;
    public isCollapsedMotivos = false;

    numeroMedidas = 0;
    numeroMotivos = 0;

    colsMedidas: any[];
    colsMotivos: any[];

    controlDocumentalCheckFalse: boolean;
    controlIdentidadCheckFalse: boolean;
    controlFisicoCheckFalse: boolean;
    controlCOICheckFalse: boolean;

    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        //protected rechazosTracesService: RechazosTracesService,
        public datepipe: DatePipe,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.colsMedidas = [
            { field: 'Descripcion', header: 'Descripción' },
            { field: 'Extension', header: 'Extensión' },
        ];

        this.colsMotivos = [
            { field: 'Descripcion', header: 'Descripción' },
            { field: 'Extension', header: 'Extensión' },
        ];

        this.updateForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.tracesParteII?.currentValue) {
            this.updateForm();

            // Verificamos los campos de control y asignamos valores dependiendo del tipo (Rechazo o Traslado)
            this['controlDocumentalCheckFalse'] = this.tracesParteII?.ControlDocumentalCheck === null;
            this['controlIdentidadCheckFalse'] = this.tracesParteII?.ControlIdentidadCheck === null;
            this['controlFisicoCheckFalse'] = this.tracesParteII?.ControlFisicoCheck === null;
            this['controlCOICheckFalse'] = this.tracesParteII?.ControlCOICheck === null;

            this.numeroMedidas = this.tracesParteII?.MedidasList.length;
            this.numeroMotivos = this.tracesParteII?.MotivosList.length;
        }
    }

    private updateForm(): void {
        this.formGroup.patchValue({
            ControlDocumentalCheck: this.tracesParteII?.ControlDocumentalCheck,
            ControlDocumentalResult: this.tracesParteII?.ControlDocumentalResult,
            ControlIdentidadCheck: this.tracesParteII?.ControlIdentidadCheck,
            ControlIdentidadResult: this.tracesParteII?.ControlIdentidadResult,
            ControlFisicoCheck: this.tracesParteII?.ControlFisicoCheck,
            ControlFisicoResult: this.tracesParteII?.ControlFisicoResult,
            ControlCOICheck: this.tracesParteII?.ControlCOICheck,
            ControlCOIResult: this.tracesParteII?.ControlCOIResult,
            Conclusion: this.tracesParteII?.Conclusion,
            FechaInspeccion: this.datepipe.transform(this.tracesParteII?.FechaInspeccion, 'dd/MM/yyyy'),
            NombreInspector: this.tracesParteII?.NombreInspector,
            PaisInspector: this.tracesParteII?.PaisInspector,
            NombrePIF: this.tracesParteII?.NombrePIF,
            PaisPIF: this.tracesParteII?.PaisPIF,
            MedidasList: this.tracesParteII?.MedidasList,
            MotivosList: this.tracesParteII?.MotivosList,
        });

        this.form = this.formGroup;
    }
}
